export default __webpack_public_path__ + "static/media/Sunmi.aa55ac23.svg";